<template>
  <v-row class="mt-1">
    <v-col cols="12">
      <v-list three-line v-if="getAtestadosFiltrados().length > 0">
        <template v-for="(atestado, i) in getAtestadosFiltrados()">
          <v-list-item :key="i">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{
                atestado.titulo
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                atestado.descsituacao
              }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ atestado.datas }}</v-list-item-subtitle>
              <v-list-item-subtitle
                class="pt-2 pb-1"
                v-if="atestado.status == 2"
              >
                <editar-atestado :atestado="atestado" />
              </v-list-item-subtitle>              
            </v-list-item-content>
            <v-list-item-action>
              <v-row>
                <v-col>
                  <v-chip
                    :x-small="$mq == 'sm'"
                    :small="$mq != 'sm'"
                    :style="getColorStatus(atestado)"
                    class="white--text mr-1"
                    >{{ atestado.descstatus }}</v-chip
                  >
                  <opcoes-atestado :atestado="atestado" />
                </v-col>
              </v-row>              
            </v-list-item-action>
          </v-list-item>
          <v-divider
            :key="atestados.length + i"
            v-if="i != atestados.length - 1"
          ></v-divider>
        </template>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import EditarAtestado from "./components/EditarAtestado.vue";
import OpcoesAtestado from "./components/OpcoesAtestado.vue";
export default {
  components: { OpcoesAtestado, EditarAtestado },
  computed: mapState("atestado", ["atestados", "status"]),
  methods: {
    getColorStatus(atest) {
      return `background: rgb(${atest.cores[0].cor},${atest.cores[1].cor}, ${atest.cores[2].cor},.7) !important`;
    },
    getAtestadosFiltrados() {
      return this.atestados.filter((atest) => atest.status < 9);
    },
  },
};
</script>

<style>
</style>